import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import AddButton from '../../../components/AddButton';
import ModalDetail from '../../../components/DetailModal';
import SearchAdvance from '../../../components/SearchAdvance';
import SearchAdvanceForm from '../../../components/SearchAdvanceForm';
import SearchBar from '../../../components/SearchBar';
import PaginatedTable from '../../../components/PaginatedTable';

const DataMitra = () => {
  const [mitra, setMitra] = useState([]);
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [nama, setNama] = useState('');
  const [jenisMitra, setJenisMitra] = useState('');
  const [pengguna, setPengguna] = useState('');
  const [idMitra, setIdMitra] = useState('');
  const [namaIDMitra, setNamaIDMitra] = useState('');
  const [username, setUsername] = useState('');

  const [selectedMitra, setSelectedMitra] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showFields, setShowFields] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('mitra')) || [];
    setMitra(stored);
  }, [location]);

  const columns = [
    { key: 'nama', label: 'Nama Lengkap' },
    { key: 'Pengguna', label: 'Jenis Pengguna' },
    { key: 'JenisMitra', label: 'Jenis Mitra' },
    { key: 'TanggalJadiMitra', label: 'Tanggal Jadi Mitra' },
    { key: 'IDMitra', label: 'ID Mitra' },
    { key: 'NamaIDMitra', label: 'Nama ID Mitra' },
    { key: 'KodePos', label: 'Kode Pos' },
    { key: 'username', label: 'Username' },
    { key: 'password', label: 'Password' },
    
  ];

  const filteredMitra = mitra.filter((item) => {
    const tgl = item.TanggalJadiMitra;

    if (fromDate && tgl < fromDate) return false;
    if (toDate && tgl > toDate) return false;
    if (nama && !item.nama?.toLowerCase().includes(nama.toLowerCase())) return false;
    if (jenisMitra && !item.JenisMitra?.toLowerCase().includes(jenisMitra.toLowerCase())) return false;
    if (pengguna && !item.Pengguna?.toLowerCase().includes(pengguna.toLowerCase())) return false;
    if (idMitra && !item.IDMitra?.toLowerCase().includes(idMitra.toLowerCase())) return false;
    if (namaIDMitra && !item.NamaIDMitra?.toLowerCase().includes(namaIDMitra.toLowerCase())) return false;
    if (username && !item.username?.toLowerCase().includes(username.toLowerCase())) return false;
    if (
      search &&
      ![item.nama, item.JenisMitra, item.Pengguna, item.IDMitra, item.NamaIDMitra, item.username].some((field) =>
        field?.toString().toLowerCase().includes(search.toLowerCase())
      )
    )
      return false;

    return true;
  });

  const handleEdit = (index) => {
    localStorage.setItem('editMitra', JSON.stringify(filteredMitra[index]));
    navigate('/edit-mitra');
  };

  const handleDelete = (index) => {
    if (window.confirm('Yakin ingin menghapus data ini?')) {
      const updated = [...mitra];
      const realIndex = mitra.findIndex((item) => item === filteredMitra[index]);
      updated.splice(realIndex, 1);
      setMitra(updated);
      localStorage.setItem('mitra', JSON.stringify(updated));
    }
  };

  const handleView = (index) => {
    const selected = filteredMitra[index];
    if (selected) {
      setSelectedMitra(selected);
      setShowDetailModal(true);
    }
  };

  const handleClearFilters = () => {
    setFromDate('');
    setToDate('');
    setNama('');
    setJenisMitra('');
    setPengguna('');
    setIdMitra('');
    setNamaIDMitra('');
    setUsername('');
  };

  return (
    <div className="pt-10 pl-64">
      <h2 className="pl-6 mb-6 text-2xl font-semibold text-green-700">Data Mitra</h2>
      <div className="p-6 mx-4 bg-white shadow rounded-xl">
        <div className="flex items-center justify-between mb-4">
          <AddButton onClick={() => navigate('/add-mitra')}  moduleName="Data Mitra"/>
          <div className="flex items-center gap-2">
            <SearchBar value={search} onChange={setSearch} />
            <SearchAdvance showFields={showFields} toggleShowFields={() => setShowFields(!showFields)} />
          </div>
        </div>

        {showFields && (
          <SearchAdvanceForm
            dateFields={[
              {
                label: 'Tanggal Jadi Mitra',
                fromValue: fromDate,
                toValue: toDate,
                onFromChange: setFromDate,
                onToChange: setToDate,
              },
            ]}
            additionalFields={[
              { label: 'Nama', value: nama, onChange: setNama },
              { label: 'Jenis Mitra', value: jenisMitra, onChange: setJenisMitra },
              { label: 'Jenis Pengguna', value: pengguna, onChange: setPengguna },
              { label: 'ID Mitra', value: idMitra, onChange: setIdMitra },
              { label: 'Nama ID Mitra', value: namaIDMitra, onChange: setNamaIDMitra },
              { label: 'Username', value: username, onChange: setUsername },
            ]}
            onClear={handleClearFilters}
          />
        )}

        <PaginatedTable
          data={filteredMitra}
          columns={columns}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onView={handleView}
          moduleName="Data Mitra"
        />

        {showDetailModal && <ModalDetail data={selectedMitra} onClose={() => setShowDetailModal(false)} />}
      </div>
    </div>
  );
};

export default DataMitra;
